import React, { useState } from 'react';
import { Box, TextField, IconButton, Collapse, InputAdornment, useTheme, useMediaQuery } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import { useDashboard } from '../../contexts/DashboardContext';

export default function GlobalFiltersBar() {
  const theme = useTheme();
  const isSFF = useMediaQuery(theme.breakpoints.down('md'));
  const { globalFilters, setGlobalFilters, clearFilters } = useDashboard();
  const [expanded, setExpanded] = useState(false);

  const hasFilters = globalFilters.search || globalFilters.dateFrom || globalFilters.dateTo;

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'action.hover' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 1, gap: 1 }}>
        <IconButton
          size="small"
          onClick={() => setExpanded((e) => !e)}
          title={expanded ? 'Hide filters' : 'Show filters'}
          sx={isSFF ? { minWidth: 44, minHeight: 44 } : {}}
        >
          <FilterListIcon fontSize="small" color={hasFilters ? 'primary' : 'inherit'} />
        </IconButton>
        {hasFilters && (
          <IconButton size="small" onClick={clearFilters} title="Clear filters" sx={isSFF ? { minWidth: 44, minHeight: 44 } : {}}>
            <ClearIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Collapse in={expanded}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: isSFF ? 'column' : 'row',
            gap: 2,
            p: 2,
            flexWrap: 'wrap',
            alignItems: 'stretch',
          }}
        >
          <TextField
            size="small"
            label="Search"
            placeholder="Filter by search..."
            value={globalFilters.search || ''}
            onChange={(e) => setGlobalFilters({ search: e.target.value })}
            sx={{ minWidth: isSFF ? '100%' : 180, flex: isSFF ? 1 : 'none' }}
            fullWidth={isSFF}
            InputProps={{
              ...(isSFF && { sx: { minHeight: 44 } }),
              endAdornment: globalFilters.search && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setGlobalFilters({ search: '' })}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            size="small"
            label="From date"
            type="date"
            value={globalFilters.dateFrom || ''}
            onChange={(e) => setGlobalFilters({ dateFrom: e.target.value })}
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: isSFF ? '100%' : 140, flex: isSFF ? 1 : 'none' }}
            fullWidth={isSFF}
            InputProps={{ sx: isSFF ? { minHeight: 44 } : {} }}
          />
          <TextField
            size="small"
            label="To date"
            type="date"
            value={globalFilters.dateTo || ''}
            onChange={(e) => setGlobalFilters({ dateTo: e.target.value })}
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: isSFF ? '100%' : 140, flex: isSFF ? 1 : 'none' }}
            fullWidth={isSFF}
            InputProps={{ sx: isSFF ? { minHeight: 44 } : {} }}
          />
        </Box>
      </Collapse>
    </Box>
  );
}
